<template>
  <v-sheet class="mt-5 pa-5" tile>
    <v-container>
      <v-card class="mx-auto" height="300px">
        <v-subheader>{{ $t('DASHBOARD.REGISTRATION') }}</v-subheader>
        <v-list dense class="pt-0">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle
                class="text-left"
                v-text="$t('DASHBOARD.UNCONFIRMED_EMAILS')"
              >
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-list-item-action-text
                >{{ info.count_unverified_emails }}
              </v-list-item-action-text>
            </v-list-item-action>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle
                class="text-left"
                v-text="$t('DASHBOARD.NEW_USERS_24H')"
              >
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-list-item-action-text
                >{{ info.count_per_24h }}
              </v-list-item-action-text>
            </v-list-item-action>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle
                class="text-left"
                v-text="$t('DASHBOARD.USERS_PER_30_DAYS')"
              >
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-list-item-action-text
                >{{ info.count_per_30days }}
              </v-list-item-action-text>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card>
    </v-container>
  </v-sheet>
</template>

<script>
export default {
  name: 'NumberOfRecentlyRegisteredUsers',

  props: {
    info: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
* {
  text-transform: none !important;
}
</style>
